import React, { useContext } from 'react';
import { Text, Box, Flex, theme } from '@xometry/xometry_loft';
import ShippingAddressBlock from '../../../ShippingAddress';
import AuthContext from '@xometry/auth-context';
import NotificationContext from '../../../../contexts/Notification';
import { entityTypeEnum } from '../../../ShippingAddress/types';
interface Props {
  orgId: string;
  onOnboardingActionCompleted: () => void;
}

const TeamShipping = ({ orgId, onOnboardingActionCompleted }: Props) => {
  const { refresh } = useContext(AuthContext);
  const { addNotification } = useContext(NotificationContext);

  return (
    <Box>
      <Flex
        marginBottom={theme.space[4]}
        alignItems="stretch"
        justifyContent="space-between"
        flexDirection="column"
      >
        <Text kind="subpage-title">Shipping Addresses</Text>
        <ShippingAddressBlock
          entityID={orgId}
          entityType={entityTypeEnum.team}
          onShippingAddressUpdate={refresh}
          displayNotification={addNotification}
          onOnboardingActionCompleted={onOnboardingActionCompleted}
        />
      </Flex>
    </Box>
  );
};

export default TeamShipping;
